import React, { FC } from "react";
import { StyledMuiTextField } from './styles';
import InputAdornment from '@material-ui/core/InputAdornment';

export type Props = {
  variant?: 'standard' | 'filled' | 'outlined';
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  placeholder?: string;
  inputProps?: any;
  InputProps?: any;
};

const TextField: FC<Props> = (props) => {
  function handleChange(
    event: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>
  ) {
    if (props.onChange) {
      props.onChange(event.currentTarget.value);
    }
  }

  return (
    <StyledMuiTextField
      variant={props.variant || 'outlined'}
      placeholder={props.placeholder}
      label={props.label}
      disabled={props.disabled}
      error={props.error}
      helperText={props.helperText}
      inputProps={props.inputProps}
      InputProps={{
        ...props.InputProps,
        value: props.value,
        startAdornment: (props.leftIcon &&
          <InputAdornment position="start">
            {props.leftIcon}
          </InputAdornment>
        ),
        endAdornment: (props.rightIcon &&
          <InputAdornment position="end">
            {props.rightIcon}
          </InputAdornment>
        ),
        onChange: handleChange,
      }}
    />
  );
};

export default TextField;
